import type { InsulinActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import type { DeepReadonlyObject } from "rxdb"
import type { AccountInsulin } from "src/types"

export function accountInsulinToActivityInsulin(accountInsulin: DeepReadonlyObject<AccountInsulin>): InsulinActivity["insulin_med"] {
  return {
    account_insulin_id: Number(accountInsulin.id),
    insulin_id: Number(accountInsulin.insulin_id),
    category: accountInsulin.insulin.category ?? "",
    description: accountInsulin.insulin.description ?? "",
    name: accountInsulin.name_override ?? accountInsulin.insulin.name ?? "",
    form: accountInsulin.form ?? accountInsulin.insulin.forms?.[0] ?? "",
    onset: accountInsulin.onset ?? NaN,
    peak: accountInsulin.peak ?? null,
    duration: accountInsulin.duration ?? NaN,
    precision: accountInsulin.precision,
    secondary_precision: accountInsulin.secondary_precision ?? null,
    is_basal: accountInsulin.is_basal,
  }
}
